export default __webpack_public_path__ + "static/media/star.a072ed54.svg";